module.exports = __webpack_public_path__ + "img/case-bg.a58af8bc.png";